import { __awaiter, __extends, __generator, __read } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { Module } from '.';
import { ModuleError } from './ModuleError';
var SearchPrefetch = /** @class */ (function (_super) {
    __extends(SearchPrefetch, _super);
    function SearchPrefetch(searchSettings, searchModules) {
        var _this = _super.call(this, 'Search_Prefetch') || this;
        _this.searchSettings = searchSettings;
        _this.searchModules = searchModules;
        return _this;
    }
    SearchPrefetch.prototype.initializeModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, prefetchModule, identity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.fetchModule(),
                            this.searchSettings.getIdentity(),
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 2]), prefetchModule = _a[0], identity = _a[1];
                        /**
                         * Initializing the prefetch library with the specified state
                         */
                        try {
                            prefetchModule.init({
                                puid: identity.puid,
                                cache: {
                                    createdBy: 'OfficeHome',
                                    createdAt: 0,
                                    participants: [],
                                    caches: {},
                                },
                            });
                            this.module.resolve(prefetchModule);
                        }
                        catch (_) {
                            throw new ModuleError('Search_Prefetch', 'Initialization_Error');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchPrefetch.prototype.fetchModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query;
            var _this = this;
            return __generator(this, function (_a) {
                query = ['SearchPrefetchModule'];
                return [2 /*return*/, queryCache.fetchQuery(query, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.searchModules.getModule()];
                            case 1: return [2 /*return*/, (_a.sent()).loadPrefetch()];
                        }
                    }); }); }, {
                        cacheTime: Infinity,
                        staleTime: Infinity,
                        onError: function () {
                            throw new ModuleError('Search_Prefetch', 'Fetching_Error');
                        },
                    })];
            });
        });
    };
    return SearchPrefetch;
}(Module));
export { SearchPrefetch };
//# sourceMappingURL=SearchPrefetch.js.map